export default __webpack_public_path__ + "static/media/77.97d12331.jpg";